// src/components/FormTagSelector.jsx
import React from 'react';

const FormTagSelector = ({ 
  label, 
  options, 
  selected, 
  onChange, 
  isDarkMode,
  className = 'flex flex-wrap gap-2'  // Default class for backward compatibility
}) => {
  return (
    <div className="space-y-2">
      <label className={`text-sm font-medium ${
        isDarkMode ? 'text-gray-300' : 'text-gray-700'
      }`}>
        {label}
      </label>
      <div className={className}>
        {options.map(({ type, color, Icon }) => (
          <button
            key={type}
            type="button"
            onClick={() => onChange(type)}
            className={`
              flex-1 min-w-[120px] px-3 py-2 rounded-lg flex items-center justify-center gap-2 transition-all
              ${selected === type 
                ? `${color} text-white scale-105 shadow-lg`
                : isDarkMode
                  ? 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }
            `}
          >
            {Icon && <Icon size={18} />}
            <span className="text-sm whitespace-nowrap">{type}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FormTagSelector;